import { SAVE_SEARCH_MODAL_ID } from 'tradera/apps/tradera/components/discover/components/search-results/save-search-modal';
import {
    stripPaginationFromQueryParameters,
    stripSaveSearchNameFromQueryParameters,
    toSearchString,
} from 'tradera/utils/url';
import { openModal, showSaveSearchBanner } from '../ui/reducer';
import {
    setRecentSearchLocalStorage,
    removeRecentSearchLocalStorage,
    setRecentBrandAttributesLocalStorage,
} from './helpers';
import {
    setRecentSearches,
    removeRecentSearch,
    setRecentBrandAttributes,
    setRecentSearchesFromCookie,
} from './reducer';
import * as searchGtm from 'tradera/apps/tradera/components/discover/helpers/search-gtm';
import type { AppDispatch, GetState } from 'tradera/state/configure-store';
import type { QueryParams } from 'tradera/apps/tradera/components/discover/components/filters/types';
import { syncLocalStorageToCookies } from 'tradera/state/personalisation/recent-searches-cookies';

export const addRecentSearches =
    (queryParams: QueryParams, isSavedSearch?: boolean) =>
    async (dispatch: AppDispatch, getState: GetState) => {
        const { q } = queryParams;

        const prettySearchTerm = q
            ?.toString()
            .replace(/</g, ' ')
            .replace(/>/g, ' ')
            .trim()
            .toLowerCase();

        const recentSearches = getState().personalisation.recentSearches;

        const existingSearch = recentSearches.find(
            (search) => search.text === prettySearchTerm,
        );

        let count = 1;

        const searchQueryParams = stripPaginationFromQueryParameters(
            stripSaveSearchNameFromQueryParameters(queryParams),
        );

        if (existingSearch) {
            const isSameSearch =
                toSearchString(existingSearch.queryParams).toLowerCase() ===
                toSearchString(queryParams).toLowerCase();

            if (isSameSearch) {
                count = existingSearch.count + 1;

                if (!isSavedSearch && count == 3) {
                    dispatch(
                        openModal({
                            modalId: SAVE_SEARCH_MODAL_ID,
                            data: {
                                queryParams: searchQueryParams,
                            },
                        }),
                    );
                } else if (!isSavedSearch) {
                    if (count % 2 == 0) {
                        dispatch(showSaveSearchBanner());
                        searchGtm.trackAction(
                            'Save search bottom banner',
                            'Show',
                        );
                    } else {
                        dispatch(showSaveSearchBanner(false));
                    }
                }
            } else {
                count = existingSearch.count;
            }
        }

        setRecentSearchLocalStorage(
            prettySearchTerm ?? '',
            searchQueryParams,
            count,
        );

        const newCookieValue = syncLocalStorageToCookies();
        dispatch(setRecentSearchesFromCookie(newCookieValue));

        dispatch(
            setRecentSearches({
                text: prettySearchTerm,
                count,
                queryParams: searchQueryParams,
            }),
        );
    };

export const removeRecentSearches =
    (searchTerm: string) => async (dispatch: AppDispatch) => {
        removeRecentSearchLocalStorage(searchTerm);
        const newCookieValue = syncLocalStorageToCookies();
        dispatch(setRecentSearchesFromCookie(newCookieValue));
        dispatch(removeRecentSearch(searchTerm));
    };

export const addRecentBrandAttribute =
    (filter: string, value: string | undefined) =>
    async (dispatch: AppDispatch) => {
        if (!filter || !value || !filter.includes('brand')) return;
        setRecentBrandAttributesLocalStorage(filter, value);
        dispatch(setRecentBrandAttributes({ filter, value }));
    };
